import { Directive, inject, input, TemplateRef } from '@angular/core';

@Directive({ selector: '[dropdownTemplate]' })
export class DropdownTemplate {
  public templateRef = inject<TemplateRef<any>>(TemplateRef);

  public readonly type = input<string>(undefined, {
    alias: 'dropdownTemplate',
  });
}
